import React from "react";
import NamesList from "./NamesList";

const NonBlockingStatus = ({...props}) =>
  <NamesList fieldLabel="Non-Block Status" {...props}/>

export {Grouped} from "./NamesList";

export default NonBlockingStatus;
